import _ from 'underscore'
import Vue from 'vue'
import Export from '../../resources/microNoteExport'

const utils = {
  resetState(state) {
    state.exportChapterIds = [];
    state.includeInactiveMicroNotes = false;
  },
}


const state = {};
utils.resetState(state);

const getters = {
  selectedExportChapterIds(state, getters, rootState, rootGetters) {
    if (!state.exportChapterIds) return [];
    return state.exportChapterIds;
  },
  includeInactiveMicroNotes(state) {
    if (!state.includeInactiveMicroNotes) return false;
    return state.includeInactiveMicroNotes;
  },
  microNotesForSelectedChapters(state, getters, rootState, rootGetters) {
    let microNotes = rootGetters.allMicroNotes;
    microNotes = _.filter(microNotes, (microNote) => {
      if (!state.includeInactiveMicroNotes && microNote.active === false) return false;
      return _.contains(state.exportChapterIds, microNote.chapter_id);
    });

    return _.pluck(microNotes, 'id');
  }
}

const actions = {

  exportMicroNotes(context, payload) {
    let ex = payload.export;
    if (!ex) {
      return;
    }

    Export.save(ex).then((res) => {
      context.commit(`EXPORT_MICRONOTES_SUCCESS`, { export: res });
      
      var blob = new Blob([res.body]);
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = payload.fileName + ".clex";
      link.click();

      if(_.isFunction(payload.callback)) payload.callback();
    }, (res) => {
      Toast.error('Failed to export lecture note')
      if(_.isFunction(payload.callback)) payload.callback(new Error('Failed to export'));
    })
  },

  addChaptersToExport(context, payload) {
    if (!payload.chapterIds) {
      return;
    }
    context.commit(`ADD_CHAPTERS_TO_EXPORT`, payload);
  },

  removeChaptersFromExport(context, payload) {
    if (!payload.chapterIds) {
      return;
    }
    context.commit(`REMOVE_CHAPTERS_FROM_EXPORT`, payload);
  },

}

const mutations = {
  LOGOUT_SUCCESS() {
    // Clear state
    utils.resetState(state);
  },

  EXPORT_MICRONOTES_SUCCESS(state, payload) {
    utils.resetState(state);
  },

  ADD_CHAPTERS_TO_EXPORT(state, payload) {
    if (!payload.chapterIds) {
      return;
    }
    const chapterIds = payload.chapterIds;
    state.exportChapterIds = _.union(state.exportChapterIds, chapterIds);

  },

  REMOVE_CHAPTERS_FROM_EXPORT(state, payload) {
    if (!payload.chapterIds) {
      return;
    }
    const chapterIds = payload.chapterIds;
    state.exportChapterIds = _.difference(state.exportChapterIds, chapterIds);

  },

  SET_INCLUDE_INACTIVE_MICRONOTES(state, payload) {
    state.includeInactiveMicroNotes = payload.includeInactive;
  }
}



export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/micro-note-exporter.js